module.exports = __webpack_public_path__ + "img/9788958286097.caa47400.jpg";